import { ProductInventory } from '@domain/inventory/models/Inventory';
import { StockLevel } from './types';

export const STOCK_LEVEL_LABEL: Record<StockLevel, string> = {
  in_stock: 'In stock',
  low_stock: 'Low on stock',
  out_of_stock: 'Out of stock',
  unknown: 'No forecast',
};

export const getStockLevel = (inventory: ProductInventory): StockLevel => {
  if (inventory.quantity <= 0) return 'out_of_stock';
  if (inventory.weeksForecasted === 0) return 'unknown';
  if (inventory.orderWithinDays != null && inventory.orderWithinDays <= 0) {
    return 'low_stock';
  }
  return 'in_stock';
};

export const stockTone = (
  level: StockLevel
): 'primary' | 'warning' | 'error' | 'neutral' => {
  if (level === 'out_of_stock') return 'error';
  if (level === 'low_stock') return 'warning';
  if (level === 'unknown') return 'neutral';
  return 'primary';
};
